import { isBarcodeOpenAtom } from '@atoms/barcodeAtoms';
import useNativeListener from '@hooks/useNativeListener';
import { useFlow } from '@router/stackflow';
import NativeUtil from '@utils/NativeUtil';
import { useAtom } from 'jotai';

function useOpenDialog() {
  const { push } = useFlow();
  const [isBarcodeOpen, setIsBarcodeOpen] = useAtom(isBarcodeOpenAtom);

  useNativeListener('openBarcode', () => {
    const isUseBarcode = window.localStorage.getItem('useBarcode') === 'true';
    if (isUseBarcode && (!isBarcodeOpen)) {
      setIsBarcodeOpen(true);
      push('BarcodeModal', {});
      NativeUtil.postMessage('runVibration', '');
    }
  }, [isBarcodeOpen]);
}

export default useOpenDialog;
